import { Box, Tooltip, Typography } from "@mui/material";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import React from "react";
import { PreferencesContext } from "../../../../PreferenceContext";

interface LocationSelectorProps {
  organizationName: string;
  name: string;
  address: string;
  locationTypeCode: string;
  locationCity: string;
  userRole: string;
  onClick: () => void;
}

export const LocationSelector: React.FC<LocationSelectorProps> = React.memo(
  ({
    organizationName,
    name,
    address,
    locationTypeCode,
    locationCity,
    userRole,
    onClick,
  }) => {
    const { userContext, updateUserContext } =
      React.useContext(PreferencesContext);

    const isOutreachLocation = locationTypeCode === "OUTREACH";

    if (userRole === "user") {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
            color: "#414D56",
          }}
        >
          <Typography
            className="secondary-color"
            sx={{
              textAlign: "right",
              margin: 0,
              padding: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontWeight: "bold",
              fontSize: "16px !important",
            }}
          >
            {name}
          </Typography>

          <Typography
            className="secondary-color"
            sx={{
              textAlign: "right",
              margin: 0,
              padding: 0,
              lineHeight: "1.2",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontWeight: "bold",
            }}
          >
            {locationCity}
          </Typography>
        </Box>
      );
    }
    if (userContext?.locationCount > 1) {
      return (
        <Tooltip title="Click to change Location" arrow placement="bottom-end">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid #e0e0e0",
              borderRadius: "6px",
              padding: { xs: "4px 8px", sm: "6px 10px" },
              cursor: "pointer",
              transition: "0.2s",
              borderColor: "#e0e0e0",
              backgroundColor: "transparent",
              "&:hover": { borderColor: "#363a3dff" },
              gap: 2,
              maxWidth: { xs: "180px", sm: "250px" },
            }}
            onClick={onClick}
            // onClick={() => {
            //   if (userRole !== "user") {
            //     onClick();
            //   }
            // }}
          >
            <SwapVertIcon
              style={{
                color: "#363a3dff",
                height: "15px",
                width: "15px",
                flexShrink: 0,
              }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                minWidth: 0,
                overflow: "hidden",
              }}
            >
              <Typography
                className="secondary-color"
                sx={{
                  textAlign: "right",
                  margin: 0,
                  padding: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <span style={{ fontSize: "14px", fontWeight: 600 }}>
                  {/* {isOutreachLocation ? name : organizationName} */}
                  {name}
                </span>
              </Typography>
              <Typography
                className="secondary-color"
                sx={{
                  textAlign: "right",
                  margin: 0,
                  padding: 0,
                  lineHeight: "1.2",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <span style={{ fontSize: "11px" }}>
                  {/* {isOutreachLocation ? locationCity : name} */}
                  {locationCity}
                </span>
                {/* {address && <span style={{ fontSize: "11px" }}>{' - '}{address}</span>} */}
              </Typography>
            </Box>
          </Box>
        </Tooltip>
      );
    } else {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
            color: "#414D56",
          }}
        >
          <Typography
            className="secondary-color"
            sx={{
              textAlign: "right",
              margin: 0,
              padding: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontWeight: "bold",
              fontSize: "14px !important",
            }}
          >
            {name}
          </Typography>

          <Typography
            className="secondary-color"
            sx={{
              textAlign: "right",
              margin: 0,
              padding: 0,
              lineHeight: "1.2",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontSize: "12px !important",
            }}
          >
            {locationCity}
          </Typography>
        </Box>
      );
    }
  },
);

LocationSelector.displayName = "LocationSelector";
